import { Box, HStack, Slider } from "@chakra-ui/react";
import i18next from "i18next";
import { RiskFactorSelector } from "./RiskFactorSelector";
import { ScoreBox } from "./ScoreBox";
import { ScoreFilterHeader } from "./ScoreFilterHeader";
import {
  ScoreFilter,
  ScoreFilterType,
  ResultsScoreLimits,
} from "../../../../../map/models/MapFilters";
import { useState } from "react";

const toPercent = (x: number, limit: ResultsScoreLimits) =>
  ((x - limit.min) / (limit.max - limit.min)) * 100;
const fromPercent = (x: number, limit: ResultsScoreLimits) =>
  (x / 100) * (limit.max - limit.min) + limit.min;

interface Props {
  filter?: ScoreFilter;
  setFilter: (filter: ScoreFilter) => void;
  maxLimit?: number;
  limits: Map<string, ResultsScoreLimits>;
}
export const GlobalScoreFilter: React.FC<Props> = ({
  filter,
  setFilter,
  limits,
}) => {
  const [showRange, setShowRange] = useState(
    filter?.type === ScoreFilterType.Limits
  );

  const limit = limits.get("global")!;
  const value = [
    filter?.type === ScoreFilterType.Limits ? filter.limits.min : limit.min,
    filter?.type === ScoreFilterType.Limits ? filter.limits.max : limit.max,
  ];
  const valuePercent = [toPercent(value[0], limit), toPercent(value[1], limit)];

  return (
    <>
      <ScoreFilterHeader
        title={i18next.t("map:filters.score.byOverallNodeTitle")}
        showRange={showRange}
        setShowRange={setShowRange}
      />
      <Box my={4}>
        {showRange ? (
          <HStack my={2}>
            <ScoreBox showValue value={Math.round(value[0])} />
            <Slider.Root
              flexGrow={1}
              value={valuePercent}
              onValueChange={({ value }) => {
                const [min, max] = value;
                setFilter({
                  type: ScoreFilterType.Limits,
                  limits: {
                    min: fromPercent(min, limit),
                    max: fromPercent(max, limit),
                  },
                });
              }}
            >
              <Slider.Control>
                <Slider.Track>
                  <Slider.Range bg="primary.500" />
                </Slider.Track>
                <Slider.Thumbs />
              </Slider.Control>
            </Slider.Root>
            <ScoreBox showValue value={Math.round(value[1])} />
          </HStack>
        ) : (
          <RiskFactorSelector filter={filter} setFilter={setFilter} />
        )}
      </Box>
    </>
  );
};
